import { Component, OnInit, Input, OnDestroy, Renderer2 } from '@angular/core';
import { NavigationService } from '../../../shared/services/navigation.service';
import { Subscription } from 'rxjs/Subscription';
import { ThemeService } from '../../../shared/services/theme.service';
import { TranslateService } from '@ngx-translate/core';
import { LayoutService } from '../../services/layout.service';
import { InternalStorage, UserProfileApi } from '../../services/sdk/index';
import { Router } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';

@Component({
    selector: 'app-header-top',
    templateUrl: './header-top.component.html',
    styleUrls: ['./header-top.component.css']
})
export class HeaderTopComponent implements OnInit, OnDestroy {
    layoutConf: any;
    menuItems: any;
    menuItemSub: Subscription;
    egretThemes: any[] = [];
    settings: any;
    protected prefix = '$LoopBackSDK$'; // copied directly from the loopback auth service
    availableSettings = [
        {
            name: 'Application Settings',
            link: '/settings/app'
        },
        {
            name: 'Storage Settings',
            link: '/settings/storage'
        },
        {
            name: 'SMS Settings',
            link: '/settings/sms'
        },
        {
            name: 'Users',
            link: '/settings/users'
        },
        {
            name: 'Account & Billing',
            link: '/settings/account-billing'
        },
        {
            name: 'Import Data',
            link: '/settings/import-data'
        },
        {
            name: 'Export Data',
            link: '/settings/export-data'
        }
    ];
    @Input() notificPanel;

    constructor(
        private layout: LayoutService,
        private navService: NavigationService,
        public themeService: ThemeService,
        public translate: TranslateService,
        private renderer: Renderer2,
        private userProfileApi: UserProfileApi,
        private storage: InternalStorage,
        private router: Router
    ) {
        this.settings = JSON.parse(localStorage.getItem('host_configs'));
    }

    ngOnInit() {
        this.layoutConf = this.layout.layoutConf;
        this.egretThemes = this.themeService.egretThemes;
        this.menuItemSub = this.navService.menuItems$.subscribe(res => {
            res = res.filter(
                item => item.type !== 'icon' && item.type !== 'separator'
            );
            const limit = 6;
            const mainItems: any[] = res.slice(0, limit);
            if (res.length <= limit) {
                return (this.menuItems = mainItems);
            }
            const subItems: any[] = res.slice(limit, res.length - 1);
            mainItems.push({
                name: 'More',
                type: 'dropDown',
                tooltip: 'More',
                icon: 'more_horiz',
                sub: subItems
            });
            this.menuItems = mainItems;
        });
    }

    ngOnDestroy() {
        this.menuItemSub.unsubscribe();
    }

    changeTheme(theme) {
        this.themeService.changeTheme(this.renderer, theme);
    }

    toggleNotific() {
        this.notificPanel.toggle();
    }

    toggleSidenav() {
        if (this.layoutConf.sidebarStyle === 'closed') {
            return this.layout.publishLayoutChange({
                sidebarStyle: 'full'
            });
        }
        this.layout.publishLayoutChange({
            sidebarStyle: 'closed'
        });
    }

    signOut() {
        this.storage.remove(`${this.prefix}userRole`);
        this.userProfileApi.logout();
        this.router.navigate(['/sessions/signin']);
    }
}
